(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["FOOTER-YJR"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-yjr-col-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.innerWidth > 768) return;
      var col = btn.closest('[data-yjr-col]');
      if (!col) return;
      var open = col.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["YJR-IMAGENES"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-yjr-video-wrap]').forEach(function (wrap) {
    var v = wrap.querySelector('video');
    if (!v) return;
    v.muted = true;

    function reveal() { wrap.classList.add('is-loaded'); }

    function checkFull() {
      try {
        if (v.buffered.length && v.duration && v.buffered.end(v.buffered.length - 1) >= v.duration - 0.25) {
          reveal();
        }
      } catch (e) {}
    }

    // Listo cuando puede reproducirse sin cortes (suficiente buffer = se ve nítido)
    if (v.readyState >= 4) { reveal(); }
    v.addEventListener('canplaythrough', reveal);
    v.addEventListener('progress', checkFull);
    v.addEventListener('loadeddata', checkFull);

    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["YJR-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-yjr-header]');
    if (!header) return;

    var burger = header.querySelector('[data-yjr-burger]');
    if (burger) {
      burger.addEventListener('click', function () {
        var open = header.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.style.overflow = open ? 'hidden' : '';
      });
    }

    var toggles = header.querySelectorAll('[data-yjr-submenu]');
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.yjr-drawer__item');
        if (!item) return;
        var expanded = item.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });

    var closeDelay = parseInt(header.getAttribute('data-close-delay') || '250', 10);
    var navItems = header.querySelectorAll('.yjr-header__inner--desktop .yjr-nav__item');
    var blurPx = parseInt(header.getAttribute('data-menu-blur') || '0', 10);
    var headerRoot = header;
    while (headerRoot.parentElement && headerRoot.parentElement !== document.body) { headerRoot = headerRoot.parentElement; }
    function setPageBlur(on) {
      if (!blurPx) return;
      var targets = [];
      Array.prototype.slice.call(document.body.children).forEach(function (el) {
        if (el === headerRoot) return;
        var tag = el.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'NOSCRIPT') return;
        targets.push(el);
      });
      if (!targets.length) {
        ['main', 'footer'].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) { if (!el.contains(header)) targets.push(el); });
        });
      }
      targets.forEach(function (el) {
        el.style.transition = 'filter .3s ease';
        el.style.filter = on ? 'blur(' + blurPx + 'px)' : '';
      });
    }
    function syncMenuOpen() {
      var anyOpen = window.innerWidth > 768 && !!header.querySelector('.yjr-nav__item.is-open');
      setPageBlur(anyOpen);
    }
    navItems.forEach(function (item) {
      var dd = item.querySelector('.yjr-dropdown');
      if (!dd) return;
      var timer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        item.classList.add('is-open');
        syncMenuOpen();
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { item.classList.remove('is-open'); syncMenuOpen(); }, closeDelay);
      });
    });

    function alignDropdowns() {
      var navEl = header.querySelector('.yjr-header__inner--desktop .yjr-nav');
      if (!navEl) return;
      var r = navEl.getBoundingClientRect();
      header.style.setProperty('--yjr-dd-left', Math.max(0, r.left) + 'px');
      header.style.setProperty('--yjr-dd-right', Math.max(0, window.innerWidth - r.right) + 'px');
    }
    alignDropdowns();
    window.addEventListener('load', alignDropdowns);
    window.addEventListener('resize', alignDropdowns);
    setTimeout(alignDropdowns, 300);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(alignDropdowns); }

    window.addEventListener('resize', function () {
      if (window.innerWidth > 768 && header.classList.contains('is-open')) {
        header.classList.remove('is-open');
        document.body.style.overflow = '';
        if (burger) burger.setAttribute('aria-expanded', 'false');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
